import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";

let date = new Date();
const currentTime = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');

export const newEmployeeInitialValue = {
    isActive: "active",
    isFromHyper: "false",
    firstName: "",
    lastName: "",
    fatherFirstName: "",
    fatherLastName: "",
    motherFirstName: "",
    motherLastName: "",
    phone: "",
    sex: "",
    birthDate: "",
    vatNumber: "",
    amka: "",
    amika: "",
    employeeCategory: "",
    employeeType: "",
    specialty: "",
    installation: "",
    employmentDate: "",
    salary: 0,
    resignationDate: "",
    resignationCause: "",
    notes: "",
    email: "",
    ama: "",

    workingDaysPerWeek: "",
    workingHoursPerWeek: "",
    symbatikesWorkingHoursPerWeek: "",
    flexibleAttendanceMinutes: "",
    workingExperienceYears: "",
    firstYearPermits: "",
    breakMinutes: "",
    breakMinutesWhen: "in",
    autoSendErganiCard: false,
    erganiCard: false,
    kathestos: "full-time",
    bankInfo: []
}

const newAccountingAccountInitialValue = {
    isActive: "active",
    category: "",
    categoryName: "",
    code: "",
    name: "",
    balance: 0,
    alternativeName: "",
    transferable: "active",
    movable: "active",
    vat: "",
    vatreason: "",
    isNetValue: "false",
    subAccount: "",
    notes: "",
    taxType: "",
    withHoldTax: "",
    otherTax: "",
    fee: "",
    stamp: "",
    mydata: [],
    clientCategories: [],
    supplierCategories: [],
    employeeCategories: []
}

export const newAccountingRecordInitialValue = {
    category: "",
    categoryName: "",
    myDataType: "",
    subCategory: "",
    subCategoryName: "",
    documentType: "",
    documentTypeName: "",
    recordType: "normal",
    date: null,
    time: currentTime,
    installation: "",
    preNumber: "",
    number: "",
    reason: "",
    paymentType: "",
    paymentTypeName: "",
    myDataPaymentId: "",
    bankAccount: "",
    bankAccountName: "",
    accounts: [],
    totalCredit: 0,
    totalDebit: 0,
    notes: "",
    myDataError: "",
    mark: "",
    uid: "",
    myDataStatus: "not_sent"
}

const newAccountingClosureInitialValue = {
    category: "",
    categoryName: "",
    myDataType: "",
    subCategory: "",
    subCategoryName: "",
    documentType: "",
    documentTypeName: "",
    recordType: "closure",
    date: null,
    time: currentTime,
    installation: "",
    preNumber: "",
    number: "",
    reason: "",
    paymentType: "",
    paymentTypeName: "",
    myDataPaymentId: "",
    bankAccount: "",
    bankAccountName: "",
    accounts: [],
    totalCredit: 0,
    totalDebit: 0,
    notes: "",
    myDataError: "",
    mark: "",
    uid: "",
    myDataStatus: "not_sent",
    closingAccounts: "",
    closingAt: "",
}

const accountingSettingsInitialValue = {
    categories: [
        {
            name: "",
            subCategories: [{
                name: "",
                accountingRecords: [],
                documentType: "",
                installation: "",
                reason: ""
            }]
        }
    ]
}

export const newAccountingAccountCategoryInitialValue = {
    category: "",
    mydata: [],
    subAccount: "",
    vat: "",
    vatreason: "",
    isNetValue: "false",
    taxType: "",
    withHoldTax: "",
    otherTax: "",
    fee: "",
    stamp: "",
    isActive: "active"
}

const newAccountingRecordCategoryInitialValue = {
    name: "",
    subCategories: []
}

const newAccountingRecordSubCategoryInitialValue = {
    name: "",
    documentType: "",
    reason: "",
    recordType: "normal",
    accounts: []
}

const newAccountInstanceInitialValue = {
    no: 1,
    id: 1,
    code: "",
    name: "",
    subAccountType: "",
    isNetValue: "false",
    vat: "",
    taxType: "",
    withHoldTax: "",
    otherTax: "",
    fee: "",
    stamp: "",
    vatReason: "",
    subAccountCategories: [],
    subAccountData: [],
    classificationType: "",
    classificationCategory: "",
    mydata: [],
    subAccount: "",
    subAccountId: "",
    credit: "",
    debit: ""
}

const initIsozygioRequestData = {
    degree: 4,
    date_from: "",
    date_to: "",
    installation: "",
    countClosure: true,
    showNonMovementAcc: false,
    analysis: [],
    code_prefix: "",
}

const initIsozygioResponseData = {}

const initIsozygioDisplayData = {
    fontSize: 14,
    degreeTotals: [],
}

const initIEBookRequestData = {
    bookOption: "income",
    date_from: "",
    date_to: "",
    installation: "",
    page: 1,
}

const initIEBookResponseData = {
    data: [],
    columns: [],
    totalPages: 0,
}

const initCalendarReportRequestData = {
    code_prefix: "",
    date_from: "",
    date_to: "",
    installation: "",
    subAccount: "",
    subAccountInput: "",
}

const initCalendarReportResponseData = []

const initCalendarReportDisplayData = {
    fontSize: 14,
    selectedRow: 0,
}

const initAccountsReportRequestData = {
    code_prefix: "",
    analysis: [],
    date_from: "",
    date_to: "",
    installation: "",
    subAccount: "",
    subAccountInput: "",
}

const initAccountsReportResponseData = {}

const initAccountsReportDisplayData = {
    fontSize: 14,
    selectedRow: 0,
}

const initGeneralCalendarReportRequestData = {
    page: 1,
    code_prefix: "",
    date_from: "",
    date_to: "",
    installation: "",
    subAccount: "",
    subAccountInput: "",
    onlyAnamorfosis: "false",
}

const initGeneralCalendarReportResponseData = {
    data: [],
    totalPages: 0,
}

const initGeneralCalendarReportDisplayData = {
    fontSize: 14,
}

const newBankInfoInitialValue = {
    bankFriendlyName: "",
    bankInstitute: "",
    iban: ""
}

const initVatInfoReportRequestData = {
    firstLoad: true,
    page: 1,
    date_from: moment().startOf('month').format("DD/MM/YYYY"),
    date_to: moment().endOf('month').format("DD/MM/YYYY"),
    grouped_per_day: "false",
    lastUpdate: ""
}

const initVatInfoReportResponseData = {
    data: [],
    columns: [],
    totals: {},
    totalPages: 0,
    filters: {},
    appliedGrouped: "false"
}

const initSubmittedVatDeclarationsRequestData = {
    month: [],
    declarationType: [],
    submissionDate_from: "",
    submissionDate_to: "",
    field_311_from: "",
    field_311_to: "",
    field_367_from: "",
    field_367_to: "",
    field_470_from: "",
    field_470_to: "",
    field_480_from: "",
    field_480_to: "",
    page: 1,
};

const initSubmittedVatDeclarationsResponseData = {
    data: [],
    totalPages: 0,
};

const initSubmittedF4DeclarationsRequestData = {
    month: [],
    declarationType: [],
    submissionDate_from: "",
    submissionDate_to: "",
    total_bc5_from: "",
    total_bc5_to: "",
    total_bc6_from: "",
    total_bc6_to: "",
    total_bc7_from: "",
    total_bc7_to: "",
    total_bc8_from: "",
    total_bc8_to: "",
    page: 1,
};

const initSubmittedF4DeclarationsResponseData = {
    data: [],
    totalPages: 0,
};

const initSubmittedF5DeclarationsRequestData = {
    month: [],
    declarationType: [],
    submissionDate_from: "",
    submissionDate_to: "",
    total_bc5_from: "",
    total_bc5_to: "",
    total_bc6_from: "",
    total_bc6_to: "",
    total_bc7_from: "",
    total_bc7_to: "",
    page: 1,
};

const initSubmittedF5DeclarationsResponseData = {
    data: [],
    totalPages: 0,
};

const initUnregulatedDebtsRequestData = {
    status: "ALL",
    taxType: "",
    taxYear: "2026",
    doy: "",
    initial_amount_from: "",
    initial_amount_to: "",
    total_amount_from: "",
    total_amount_to: "",
    assessment_date_from: "",
    assessment_date_to: "",
    page: 1,
};

const initUnregulatedDebtsResponseData = {
    data: [],
    totalPages: 0,
};

const emptyTableBRow = () => ({
    ctryDesc: "",
    bc4: "",
    bc5: "",
    bc6: "",
    bc7: "",
    bc8: ""
});

const emptyTableCRow = () => ({
    ctryDesc: "",
    cc4: "",
    cc5: "",
    cc6: "0",
    cc7: "0"
});

const initF4ReportRequestData = {
    date_from: moment().subtract(1, 'month').startOf('month').format("DD/MM/YYYY"),
    date_to: moment().subtract(1, 'month').endOf('month').format("DD/MM/YYYY"),
};

const initF4LocalFields = {
    f003_num: "",
    f012_name: "",
    f013_fname: "",
    f018_phone_code: "",
    f019_fax: "",
    f019_fax_code: "",
    f021_file: ""
};

const emptyTableBF5Row = () => ({
    ctryDesc: "",
    bc4: "",
    bc5: "",
    bc6: "",
    bc7: ""
});

const initF5ReportRequestData = {
    date_from: moment().subtract(1, 'month').startOf('month').format("DD/MM/YYYY"),
    date_to: moment().subtract(1, 'month').endOf('month').format("DD/MM/YYYY"),
};

const initF5LocalFields = {
    f003_num: "",
    f012_name: "",
    f013_fname: "",
    f018_phone_code: "",
    f019_fax: "",
    f019_fax_code: "",
    f021_file: ""
};

const initialState = {
    newEmployeeInitialValue: newEmployeeInitialValue,
    newAccountingAccountInitialValue: newAccountingAccountInitialValue,
    newEmployee: newEmployeeInitialValue,
    editEmployee: newEmployeeInitialValue,
    newAccountingAccount: newAccountingAccountInitialValue,
    editAccountingAccount: newAccountingAccountInitialValue,
    newAccountingClosure: newAccountingClosureInitialValue,
    accountingSettings: accountingSettingsInitialValue,
    searchEmployees: [],
    totalItemsES: 0,
    perPageES: 0,
    searchAccountingAccounts: [],
    totalItemsAAS: 0,
    perPageAAS: 0,
    accountingCategories: [],
    newAccountingRecordCategory: newAccountingRecordCategoryInitialValue,
    newAccountingRecordSubCategory: newAccountingRecordSubCategoryInitialValue,
    newAccountInstance: newAccountInstanceInitialValue,
    accountingRecordCategories: [],
    accountingRecordSubcategories: [],
    accountingAdvancedTypes: [],
    newAccountingRecord: newAccountingRecordInitialValue,
    editAccountingRecord: newAccountingRecordInitialValue,
    searchAccountingRecords: [],
    accountingClosureTemplates: [],
    totalItemsAR: 0,
    perPageAR: 0,
    autoNewRecordData: null,

    paymentTypes: [],
    forceRefreshAccounts: false,

    // Isozygio report
    isozygioRequestData: {},
    isozygioResponseData: {},
    isozygioDisplayData: {},

    // Accounts report
    accountsReportRequestData: {},
    accountsReportResponseData: {},
    accountsReportDisplayData: {},

    // Accounts Calendar Report
    calendarReportRequestData: {},
    calendarReportResponseData: {},
    calendarReportDisplayData: {},

    // Accounting General Calendar Report
    generalCalendarReportRequestData: {},
    generalCalendarReportResponseData: {},
    generalCalendarReportDisplayData: {},

    // Income / Expense Book
    ieBookRequestData: {},
    ieBookResponseData: {},

    // Bank Information
    newBankInfoInitialValue: newBankInfoInitialValue,
    editBankInfo: newBankInfoInitialValue,
    newBankInfo: newBankInfoInitialValue,

    // Accounting Bridge
    accountingBridgeFilters: {
        section: "",
        date_from: "",
        date_to: "",
        showFilter: "",
        general: "",
    },
    accountingBridgeReportData: [],
    accountingBridgeCustomSelections: [],

    // Accounting Year Report
    accountingYearReportRequestData: {
        firstLoad: true,
        forCompany: [],
    },
    accountingYearReportResponseData: {
        data: [],
        columns: [],
    },

    // VAT Info Report
    vatInfoReportRequestData: initVatInfoReportRequestData,
    vatInfoReportResponseData: initVatInfoReportResponseData,

    // Issue Φ2
    f2ReportRequestData: {},
    f2ReportResponseData: null,
    f2ZoomLevel: 1,
    f2ExportSource: "myData",
    f2VisibleColumns: { erp: true, myData: true, accounting: true },

    // Issue Φ4
    f4ReportRequestData: initF4ReportRequestData,
    f4TableBData: Array.from({ length: 14 }, emptyTableBRow),
    f4TableCData: Array.from({ length: 5 }, emptyTableCRow),
    f4LocalFields: initF4LocalFields,
    f4IsAmending: false,
    f4ZoomLevel: 1,

    // Issue Φ5
    f5ReportRequestData: initF5ReportRequestData,
    f5TableBData: Array.from({ length: 25 }, emptyTableBF5Row),
    f5LocalFields: initF5LocalFields,
    f5IsAmending: false,
    f5ZoomLevel: 1,

    isTaxisScrapingActive: false,
    taxisScrapingMessage: "",

    // Φ2 Rules Accordions
    f2AccordionActiveKeys: [],

    // Submitted Φ2 Declarations
    submittedVatDeclarationsRequestData: initSubmittedVatDeclarationsRequestData,
    submittedVatDeclarationsResponseData: initSubmittedVatDeclarationsResponseData,
    submittedVatDeclarations: [],
    totalItemsSVD: 0,
    perPageSVD: 0,
    selectedSubmittedVatDeclarations: {},

    // Submitted Φ4 Declarations
    submittedF4DeclarationsRequestData: initSubmittedF4DeclarationsRequestData,
    submittedF4DeclarationsResponseData: initSubmittedF4DeclarationsResponseData,
    submittedF4Declarations: [],
    totalItemsSF4: 0,
    perPageSF4: 20,
    selectedSubmittedF4Declarations: {},

    // Submitted Φ5 Declarations
    submittedF5DeclarationsRequestData: initSubmittedF5DeclarationsRequestData,
    submittedF5DeclarationsResponseData: initSubmittedF5DeclarationsResponseData,
    submittedF5Declarations: [],
    totalItemsSF5: 0,
    perPageSF5: 20,
    selectedSubmittedF5Declarations: {},

    f2ClassicRules: null,
    f2AccountingRecordCreationRules: null,
    f2RulesInitialFetchDone: false,

    f2FormOptions: {
        declarationType: null,
        installment523: 2,
        returnReason507: null,
        notes: "",
        noIbanAccount: false
    },

    // myAADE Unregulated Debts
    unregulatedDebtsRequestData: initUnregulatedDebtsRequestData,
    unregulatedDebtsResponseData: initUnregulatedDebtsResponseData,
    unregulatedDebts: [],
    totalItemsSUD: 0,
    perPageSUD: 20,
    debtsSummaryData: {
        nonOverdueTotal: 0,
        overdueTotal: 0,
        surchargesTotal: 0,
        grandTotal: 0,
        paidTotal: 0
    },
    selectedUnregulatedDebts: {},

    // Taxisnet
    taxisCredentials: {
        username: "",
        password: "",
        isAccountant: false,
        accountantAfm: ""
    },

    // MyAADE
    accountingCompanyCredentials: {
        username: "",
        password: ""
    },

    // Operating Statement Report
    operatingStatementReportResponseData: {},

    // Banking Agreements
    bankingAgreementsRequestData: {
        page: 1,
        date_from: moment().startOf("year").format("DD/MM/YYYY"),
        date_to: moment().endOf("year").format("DD/MM/YYYY"),
        status: "success",
    },
    bankingAgreementsResponseData: {
        totalPages: 0,
        data: []
    },

    // Banking Agreements Admin
    bankingAgreementsAdminRequestData: {
        page: 1,
        date_from: moment().startOf("year").format("DD/MM/YYYY"),
        date_to: moment().endOf("year").format("DD/MM/YYYY"),
        status: "success",
        company: "",
    },
    bankingAgreementsAdminResponseData: {
        totalPages: 0,
        data: []
    },

    // Banking Transactions
    myConnectedBanks: [],
    bankingTransactionsRequestData: {
        page: 1,
        accountId: "",
        status: [],
        description: "",
        amount_from: "",
        amount_to: "",
        date_from: "",
        date_to: "",
        sign: "",
    },
    bankingTransactionsResponseData: {
        totalPages: 0,
        data: [],
        transactionIds: [],
        differencePage: 0,
    },
    bankingTransactionsSelectedTransactions: [],
    bankingTransactionReportUniqueSelection: "", // For making blue background

    // AI Banking Transactions
    bankingAITransactionsRequestData: {
        page: 1,
        accountId: "",
        status: [],
        description: "",
        amount_from: "",
        amount_to: "",
        date_from: "",
        date_to: "",
        sign: "",
        ai_status: [],
        ai_score_from: "",
        ai_score_to: "",
        subcategories: [],
        sortField: "valueDate",
        sortBy: "DESC",
    },
    bankingAITransactionsResponseData: {
        totalPages: 0,
        data: [],
        transactionIds: [],
        differencePage: 0,
    },
    bankingAITransactionsSelectedTransactions: [],
    bankingAITransactionReportUniqueSelection: "", // For making blue background

    // New banking agreement required modal
    bankAgreementAttention: false,
    showNewBankAgreementAttentionModal: false,
    showNewBankAgreementAttentionModalMessage: "",

    // Hook Transaction Modal
    showHookTransactionModal: false,
    hookTransactionModalData: {
        transaction: null,
        section: "",
        documentHooks: [],
    },

    // Banking Settings
    bankingCategories: [],
    bankingSubCategories: [],
}

export const AccountingSlice = createSlice({
    name: "accounting",
    initialState,
    reducers: {
        setNewEmployee: (state, {payload}) => {
            state.newEmployee = payload;
        },
        setEditEmployee: (state, {payload}) => {
            state.editEmployee = payload;
        },
        setNewAccountingAccount: (state, {payload}) => {
            state.newAccountingAccount = payload;
        },
        setEditAccountingAccount: (state, {payload}) => {
            state.editAccountingAccount = payload;
        },
        setSearchEmployees: (state, {payload}) => {
            state.searchEmployees = payload;
        },
        setSearchAccountingAccounts: (state, {payload}) => {
            state.searchAccountingAccounts = payload;
        },
        setTotalItemsES: (state, {payload}) => {
            state.totalItemsES = payload;
        },
        setperPageES: (state, {payload}) => {
            state.perPageES = payload;
        },
        setTotalItemsAAS: (state, {payload}) => {
            state.totalItemsAAS = payload;
        },
        setperPageAAS: (state, {payload}) => {
            state.perPageAAS = payload;
        },
        resetNewEmployee: (state) => {
            state.newEmployee = state.newEmployeeInitialValue;
        },
        resetNewAccountingAccount: (state) => {
            state.newAccountingAccount = state.newAccountingAccountInitialValue;
        },
        setAccountingSettings: (state, {payload}) => {
            state.accountingCategories = payload;
        },
        setNewAccountingRecordCategory: (state, {payload}) => {
            state.newAccountingRecordCategory = payload;
        },
        resetNewAccountingRecordCategory: (state) => {
            state.newAccountingRecordCategory = newAccountingRecordCategoryInitialValue;
        },
        setNewAccountingRecordSubCategory: (state, {payload}) => {
            state.newAccountingRecordSubCategory = payload;
        },
        resetNewAccountingRecordSubCategory: (state) => {
            state.newAccountingRecordSubCategory = newAccountingRecordSubCategoryInitialValue;
        },
        setAccountingRecordCategories: (state, {payload}) => {
            state.accountingRecordCategories = payload;
        },
        setAccountingRecordSubcategories: (state, {payload}) => {
            state.accountingRecordSubcategories = payload;
        },
        setAccountingAdvancedTypes: (state, {payload}) => {
            state.accountingAdvancedTypes = payload;
        },
        setNewAccountInstance: (state, {payload}) => {
            state.newAccountInstance = payload;
        },
        resetNewAccountingInstance: (state) => {
            state.newAccountInstance = newAccountInstanceInitialValue;
        },
        setNewAccountingRecord: (state, {payload}) => {
            state.newAccountingRecord = payload;
        },
        resetNewAccountingRecord: (state) => {
            state.newAccountingRecord = newAccountingRecordInitialValue;
        },
        softResetAccountingRecord: (state) => {
            state.newAccountingRecord.reason = "";
        },
        setEditAccountingRecord: (state, {payload}) => {
            state.editAccountingRecord = payload;
        },
        setTotalItemsAR: (state, {payload}) => {
            state.totalItemsAR = payload;
        },
        setperPageAR: (state, {payload}) => {
            state.perPageAR = payload;
        },
        setSearchAccountingRecords: (state, {payload}) => {
            state.searchAccountingRecords = payload;
        },
        setAccountingPaymentTypes: (state, {payload}) => {
            state.paymentTypes = payload;
        },
        setAutoNewRecordData: (state, {payload}) => {
            state.autoNewRecordData = payload;
        },

        setNewAccountingClosure: (state, {payload}) => {
            state.newAccountingClosure = payload;
        },
        resetNewAccountingClosure: (state) => {
            state.newAccountingClosure = {...newAccountingClosureInitialValue};
        },
        setAccountingClosureTemplates: (state, {payload}) => {
            state.accountingClosureTemplates = payload;
        },

        // Isozygio Report
        initIsozygioReport: (state, {payload}) => {
            state.isozygioRequestData[payload.tabKey] = {...initIsozygioRequestData};
            state.isozygioResponseData[payload.tabKey] = {...initIsozygioResponseData};
            state.isozygioDisplayData[payload.tabKey] = {...initIsozygioDisplayData};
        },
        setIsozygioRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.isozygioRequestData[tabKey] = action.payload;
        },
        setIsozygioDisplayData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.isozygioDisplayData[tabKey] = action.payload;
        },
        setIsozygioResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.isozygioResponseData[tabKey] = action.payload;
        },

        // Income / Expense Book
        initIEBookReport: (state, {payload}) => {
            state.ieBookRequestData[payload.tabKey] = {...initIEBookRequestData};
            state.ieBookResponseData[payload.tabKey] = {...initIEBookResponseData};
        },
        setIEBookRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.ieBookRequestData[tabKey] = action.payload;
        },
        setIEBookResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.ieBookResponseData[tabKey] = action.payload;
        },

        // Accounting Accounts Report
        initAccountsReport: (state, {payload}) => {
            state.accountsReportRequestData[payload.tabKey] = {...initAccountsReportRequestData};
            state.accountsReportResponseData[payload.tabKey] = {...initAccountsReportResponseData};
            state.accountsReportDisplayData[payload.tabKey] = {...initAccountsReportDisplayData};
        },
        setAccountsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.accountsReportRequestData[tabKey] = action.payload;
        },
        setAccountsReportDisplayData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.accountsReportDisplayData[tabKey] = action.payload;
        },
        setAccountsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.accountsReportResponseData[tabKey] = action.payload;
        },

        // Accounts Calendar Report
        initCalendarReport: (state, {payload}) => {
            state.calendarReportRequestData[payload.tabKey] = {...initCalendarReportRequestData};
            state.calendarReportResponseData[payload.tabKey] = {...initCalendarReportResponseData};
            state.calendarReportDisplayData[payload.tabKey] = {...initCalendarReportDisplayData};
        },
        setCalendarReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.calendarReportRequestData[tabKey] = action.payload;
        },
        setCalendarReportDisplayData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.calendarReportDisplayData[tabKey] = action.payload;
        },
        setCalendarReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.calendarReportResponseData[tabKey] = action.payload;
        },

        // Accounts General Calendar Report
        initGeneralCalendarReport: (state, {payload}) => {
            state.generalCalendarReportRequestData[payload.tabKey] = {...initGeneralCalendarReportRequestData};
            state.generalCalendarReportResponseData[payload.tabKey] = {...initGeneralCalendarReportResponseData};
            state.generalCalendarReportDisplayData[payload.tabKey] = {...initGeneralCalendarReportDisplayData};
        },
        setGeneralCalendarReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.generalCalendarReportRequestData[tabKey] = action.payload;
        },
        setGeneralCalendarReportDisplayData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.generalCalendarReportDisplayData[tabKey] = action.payload;
        },
        setGeneralCalendarReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.generalCalendarReportResponseData[tabKey] = action.payload;
        },

        // Accounting Bridge
        setAccountingBridgeFilters: (state, {payload}) => {
            state.accountingBridgeFilters = payload;
        },
        setAccountingBridgeReportData: (state, {payload}) => {
            state.accountingBridgeReportData = payload;
        },
        setAccountingBridgeCustomSelections: (state, {payload}) => {
            state.accountingBridgeCustomSelections = payload;
        },

        // Accounting Year Report
        setAccountingYearReportRequestData: (state, {payload}) => {
            state.accountingYearReportRequestData = payload;
        },
        setAccountingYearReportResponseData: (state, {payload}) => {
            state.accountingYearReportResponseData = payload;
        },

        // VAT Info Report
        setVatInfoReportRequestData: (state, {payload}) => {
            state.vatInfoReportRequestData = payload;
        },
        setVatInfoReportResponseData: (state, {payload}) => {
            state.vatInfoReportResponseData = payload;
        },

        // Issue Φ2
        setF2ReportRequestData: (state, action) => {
            state.f2ReportRequestData = action.payload;
        },
        setF2ReportResponseData: (state, action) => {
            state.f2ReportResponseData = action.payload;
        },
        setF2ZoomLevel: (state, action) => {
            state.f2ZoomLevel = action.payload;
        },
        setF2FormOptions: (state, action) => {
            state.f2FormOptions = { ...state.f2FormOptions, ...action.payload };
        },
        setF2ExportSource: (state, action) => {
            state.f2ExportSource = action.payload;
        },
        setF2VisibleColumns: (state, action) => {
            state.f2VisibleColumns = action.payload;
        },

        // Issue Φ4
        setF4ReportRequestData: (state, action) => {
            state.f4ReportRequestData = { ...state.f4ReportRequestData, ...action.payload };
        },
        setF4TableBData: (state, action) => {
            state.f4TableBData = action.payload;
        },
        updateF4TableBRow: (state, action) => {
            const { rowIndex, field, value } = action.payload;
            if (state.f4TableBData[rowIndex]) {
                state.f4TableBData[rowIndex][field] = value;
            }
        },
        setF4TableCData: (state, action) => {
            state.f4TableCData = action.payload;
        },
        updateF4TableCRow: (state, action) => {
            const { rowIndex, field, value } = action.payload;
            if (state.f4TableCData[rowIndex]) {
                state.f4TableCData[rowIndex][field] = value;
            }
        },
        setF4LocalFields: (state, action) => {
            state.f4LocalFields = { ...state.f4LocalFields, ...action.payload };
        },
        setF4IsAmending: (state, action) => {
            state.f4IsAmending = action.payload;
        },
        setF4ZoomLevel: (state, action) => {
            state.f4ZoomLevel = action.payload;
        },

        // Issue Φ5
        setF5ReportRequestData: (state, action) => {
            state.f5ReportRequestData = { ...state.f5ReportRequestData, ...action.payload };
        },
        setF5TableBData: (state, action) => {
            state.f5TableBData = action.payload;
        },
        updateF5TableBRow: (state, action) => {
            const { rowIndex, field, value } = action.payload;
            if (state.f5TableBData[rowIndex]) {
                state.f5TableBData[rowIndex][field] = value;
            }
        },
        setF5LocalFields: (state, action) => {
            state.f5LocalFields = { ...state.f5LocalFields, ...action.payload };
        },
        setF5IsAmending: (state, action) => {
            state.f5IsAmending = action.payload;
        },
        setF5ZoomLevel: (state, action) => {
            state.f5ZoomLevel = action.payload;
        },
        setTaxisScrapingState: (state, action) => {
            state.isTaxisScrapingActive = action.payload.active;
            state.taxisScrapingMessage = action.payload.message || "";
        },

        setUnregulatedDebts: (state, {payload}) => {
            state.unregulatedDebts = payload;
        },
        setTotalItemsSUD: (state, {payload}) => {
            state.totalItemsSUD = payload;
        },
        setPerPageSUD: (state, {payload}) => {
            state.perPageSUD = payload;
        },
        setDebtsSummaryData: (state, {payload}) => {
            state.debtsSummaryData = payload;
        },
        setUnregulatedDebtsRequestData: (state, {payload}) => {
            state.unregulatedDebtsRequestData = payload;
        },
        setUnregulatedDebtsResponseData: (state, {payload}) => {
            state.unregulatedDebtsResponseData = payload;
        },
        setSelectedUnregulatedDebt: (state, action) => {
            const tabKey = action.meta?.tabKey || action.payload?.tabKey;
            if (tabKey) {
                state.selectedUnregulatedDebts[tabKey] = action.payload;
            }
        },
        removeSelectedUnregulatedDebt: (state, { payload }) => {
            const tabKey = typeof payload === 'string' ? payload : payload?.tabKey;
            if (tabKey && state.selectedUnregulatedDebts[tabKey]) {
                delete state.selectedUnregulatedDebts[tabKey];
            }
        },

        // Φ2 Rules Accordions
        setF2AccordionActiveKeys: (state, action) => {
            state.f2AccordionActiveKeys = action.payload;
        },

        setF2ClassicRules: (state, action) => {
            state.f2ClassicRules = action.payload;
        },
        setF2AccountingRecordCreationRules: (state, action) => {
            state.f2AccountingRecordCreationRules = action.payload;
        },
        setF2RulesInitialFetchDone: (state, action) => {
            state.f2RulesInitialFetchDone = action.payload;
        },

        // Taxisnet
        setTaxisCredentials: (state, action) => {
            state.taxisCredentials = action.payload;
        },

        // MyAADE
        setAccountingCompanyCredentials: (state, action) => {
            state.accountingCompanyCredentials = action.payload;
        },

        // Operating Statement Report
        setOperatingStatementReportResponseData: (state, {payload}) => {
            state.operatingStatementReportResponseData = payload;
        },

        // Banking Agreements Report
        setBankingAgreementsReportRequestData: (state, {payload}) => {
            state.bankingAgreementsRequestData = payload;
        },
        setBankingAgreementsReportResponseData: (state, {payload}) => {
            state.bankingAgreementsResponseData = payload;
        },

        // Banking Agreements Report Admin
        setBankingAgreementsReportAdminRequestData: (state, {payload}) => {
            state.bankingAgreementsAdminRequestData = payload;
        },
        setBankingAgreementsReportAdminResponseData: (state, {payload}) => {
            state.bankingAgreementsAdminResponseData = payload;
        },

        // Banking Transactions Report
        setMyConnectedBanks: (state, {payload}) => {
            state.myConnectedBanks = payload;
        },
        setBankingTransactionsReportRequestData: (state, {payload}) => {
            state.bankingTransactionsRequestData = payload;
        },
        setBankingTransactionsReportResponseData: (state, {payload}) => {
            state.bankingTransactionsResponseData = payload;
        },
        setBankingTransactionsSelected: (state, {payload}) => {
            state.bankingTransactionsSelectedTransactions = payload;
        },
        setBankingTransactionReportUniqueSelection: (state, {payload}) => {
            state.bankingTransactionReportUniqueSelection = payload;
        },

        // Banking AI Transactions Report
        setBankingAITransactionsReportRequestData: (state, {payload}) => {
            state.bankingAITransactionsRequestData = payload;
        },
        setBankingAITransactionsReportResponseData: (state, {payload}) => {
            state.bankingAITransactionsResponseData = payload;
        },
        setBankingAITransactionsSelected: (state, {payload}) => {
            state.bankingAITransactionsSelectedTransactions = payload;
        },
        setBankingAITransactionReportUniqueSelection: (state, {payload}) => {
            state.bankingAITransactionReportUniqueSelection = payload;
        },

        setForceRefreshAccounts: (state, {payload}) => {
            state.forceRefreshAccounts = payload;
        },

        setBankAgreementAttention: (state, {payload}) => {
            state.bankAgreementAttention = payload;
        },
        setShowNewBankAgreementAttentionModal: (state, {payload}) => {
            state.showNewBankAgreementAttentionModal = payload;
        },
        setShowNewBankAgreementAttentionModalMessage: (state, {payload}) => {
            state.showNewBankAgreementAttentionModalMessage = payload;
        },

        // Hook Transaction Modal
        setShowHookTransactionModal: (state, {payload}) => {
            state.showHookTransactionModal = payload;
        },
        setHookTransactionModalData: (state, {payload}) => {
            state.hookTransactionModalData = payload;
        },

        // Banking Settings
        setBankingCategories: (state, {payload}) => {
            state.bankingCategories = payload;
        },
        setBankingSubCategories: (state, {payload}) => {
            state.bankingSubCategories = payload;
        },

        // Bank info
        setNewBankInfo: (state, {payload}) => {
            state.newBankInfo = payload;
        },
        setEditBankInfo: (state, {payload}) => {
            state.editBankInfo = payload;
        },
        resetNewBankInfo: (state) => {
            state.newBankInfo = state.newBankInfoInitialValue;
        },
        resetEditBankInfo: (state) => {
            state.editBankInfo = state.newBankInfoInitialValue;
        },

        // Submitted Φ2 Declarations
        setSubmittedVatDeclarations: (state, {payload}) => {
            state.submittedVatDeclarations = payload;
        },
        setTotalItemsSVD: (state, {payload}) => {
            state.totalItemsSVD = payload;
        },
        setPerPageSVD: (state, {payload}) => {
            state.perPageSVD = payload;
        },
        setSelectedSubmittedVatDeclaration: (state, action) => {
            const tabKey = action.meta?.tabKey;
            if (tabKey) {
                state.selectedSubmittedVatDeclarations[tabKey] = action.payload;
            }
        },

        // Submitted Φ4 Declarations
        setSubmittedF4Declarations: (state, {payload}) => {
            state.submittedF4Declarations = payload;
        },
        setTotalItemsSF4: (state, {payload}) => {
            state.totalItemsSF4 = payload;
        },
        setPerPageSF4: (state, {payload}) => {
            state.perPageSF4 = payload;
        },
        setSelectedSubmittedF4Declaration: (state, action) => {
            const tabKey = action.meta?.tabKey;
            if (tabKey) {
                state.selectedSubmittedF4Declarations[tabKey] = action.payload;
            }
        },

        // Submitted Φ5 Declarations
        setSubmittedF5Declarations: (state, action) => {
            state.submittedF5Declarations = action.payload;
        },
        setTotalItemsSF5: (state, action) => {
            state.totalItemsSF5 = action.payload;
        },
        setPerPageSF5: (state, action) => {
            state.perPageSF5 = action.payload;
        },
        setSelectedSubmittedF5Declaration: (state, action) => {
            const tabKey = action.meta?.tabKey;
            if (tabKey) {
                state.selectedSubmittedF5Declarations[tabKey] = action.payload;
            }
        }
    }
})

export const {
    setNewEmployee,
    setEditEmployee,
    setNewAccountingAccount,
    setEditAccountingAccount,
    setSearchEmployees,
    setSearchAccountingAccounts,
    setTotalItemsES,
    setperPageES,
    setTotalItemsAAS,
    setperPageAAS,
    resetNewEmployee,
    setAccountingSettings,
    resetNewAccountingAccount,
    setNewAccountingRecordCategory,
    resetNewAccountingRecordCategory,
    setAccountingRecordCategories,
    setNewAccountingRecordSubCategory,
    resetNewAccountingRecordSubCategory,
    setAccountingAdvancedTypes,
    setNewAccountInstance,
    resetNewAccountingInstance,
    setNewAccountingRecord,
    resetNewAccountingRecord,
    softResetAccountingRecord,
    setEditAccountingRecord,
    setperPageAR,
    setTotalItemsAR,
    setSearchAccountingRecords,
    setAccountingRecordSubcategories,
    setAccountingPaymentTypes,
    setAutoNewRecordData,

    setNewAccountingClosure,
    resetNewAccountingClosure,
    setAccountingClosureTemplates,

    // Izoygio Report
    initIsozygioReport,
    setIsozygioRequestData,
    setIsozygioDisplayData,
    setIsozygioResponseData,

    // Income / Expense Book Report
    initIEBookReport,
    setIEBookRequestData,
    setIEBookResponseData,

    // Accounts Report
    initAccountsReport,
    setAccountsReportRequestData,
    setAccountsReportDisplayData,
    setAccountsReportResponseData,

    // Calendar Report
    initCalendarReport,
    setCalendarReportRequestData,
    setCalendarReportDisplayData,
    setCalendarReportResponseData,

    // General Calendar Report
    initGeneralCalendarReport,
    setGeneralCalendarReportRequestData,
    setGeneralCalendarReportDisplayData,
    setGeneralCalendarReportResponseData,

    setAccountingBridgeFilters,
    setAccountingBridgeReportData,
    setAccountingBridgeCustomSelections,

    setAccountingYearReportRequestData,
    setAccountingYearReportResponseData,

    setVatInfoReportRequestData,
    setVatInfoReportResponseData,
    setF2ReportRequestData,
    setF2ReportResponseData,
    setF2ZoomLevel,
    setF2FormOptions,
    setF2ExportSource,
    setF2VisibleColumns,

    setF2AccordionActiveKeys,

    setF2ClassicRules,
    setF2AccountingRecordCreationRules,
    setF2RulesInitialFetchDone,

    setTaxisCredentials,
    setAccountingCompanyCredentials,

    setOperatingStatementReportResponseData,

    // Banking Agreements Report
    setBankingAgreementsReportRequestData,
    setBankingAgreementsReportResponseData,

    // Banking Agreements Report Admin
    setBankingAgreementsReportAdminRequestData,
    setBankingAgreementsReportAdminResponseData,

    // Banking Transactions Report
    setMyConnectedBanks,
    setBankingTransactionsReportRequestData,
    setBankingTransactionsReportResponseData,
    setBankingTransactionsSelected,
    setBankingTransactionReportUniqueSelection,

    // Banking AI Transactions Report
    setBankingAITransactionsReportRequestData,
    setBankingAITransactionsReportResponseData,
    setBankingAITransactionsSelected,
    setBankingAITransactionReportUniqueSelection,

    // Banking Settings
    setBankingCategories,
    setBankingSubCategories,

    setForceRefreshAccounts,

    setBankAgreementAttention,
    setShowNewBankAgreementAttentionModal,
    setShowNewBankAgreementAttentionModalMessage,

    // Hook Transaction Modal
    setShowHookTransactionModal,
    setHookTransactionModalData,

    // Bank info
    setNewBankInfo,
    setEditBankInfo,
    resetNewBankInfo,
    resetEditBankInfo,

    // Submitted Φ2 Declarations
    setSubmittedVatDeclarations,
    setTotalItemsSVD,
    setPerPageSVD,
    setSelectedSubmittedVatDeclaration,

    // Submitted Φ4 Declarations
    setSubmittedF4Declarations,
    setTotalItemsSF4,
    setPerPageSF4,
    setSelectedSubmittedF4Declaration,

    // Submitted Φ5 Declarations
    setSubmittedF5Declarations,
    setTotalItemsSF5,
    setPerPageSF5,
    setSelectedSubmittedF5Declaration,

    setTaxisScrapingState,

    // Φ4
    setF4ReportRequestData,
    setF4TableBData,
    updateF4TableBRow,
    setF4TableCData,
    updateF4TableCRow,
    setF4LocalFields,
    setF4IsAmending,
    setF4ZoomLevel,

    // Φ5
    setF5ReportRequestData,
    setF5TableBData,
    updateF5TableBRow,
    setF5LocalFields,
    setF5IsAmending,
    setF5ZoomLevel,

    // myAADE Unregulated Debts
    setUnregulatedDebts,
    setTotalItemsSUD,
    setPerPageSUD,
    setDebtsSummaryData,
    setUnregulatedDebtsRequestData,
    setUnregulatedDebtsResponseData,
    setSelectedUnregulatedDebt,
    removeSelectedUnregulatedDebt
} = AccountingSlice.actions;
